<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">

          <div class="card-header pb-0">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h6 class="mb-0">Tallas disponibles</h6>
              <div class="d-flex gap-2">
                <button
                  v-if="shopifyActive"
                  type="button"
                  class="btn btn-outline-success btn-sm"
                  @click="syncShopify"
                  :disabled="isSyncing"
                >
                  <i class="fa fa-sync me-1" :class="{ 'fa-spin': isSyncing }"></i>
                  {{ isSyncing ? 'Sincronizando...' : 'Sincronizar Shopify' }}
                </button>
                <router-link
                  :to="{ name: 'Inventory Create', query: suppliesListQuery }"
                  class="btn btn-primary btn-sm"
                  data-toggle="tooltip"
                  data-original-title="Agregar insumo"
                >
                  Agregar <i class="fa fa-plus ms-1"></i>
                </router-link>
              </div>
            </div>
            <div class="row align-items-end">
              <!-- Columna de búsqueda -->
              <div class="col-md-4 mb-3">
                <label for="searchQuery" class="mb-1">Buscar</label>
                <input
                  type="text"
                  v-model="searchQuery"
                  id="searchQuery"
                  class="form-control"
                  placeholder="Buscar producto..."
                  @input="onSearchInput"
                />
              </div>
              <div class="col-md-8 mb-3 text-end">
                <button
                  type="button"
                  class="btn btn-sm btn-outline-warning me-2"
                  @click="openEgresoModal"
                >
                  <i class="fa fa-minus-circle me-1"></i> Egresos de inventario
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-danger me-2"
                  @click="exportPdf"
                  :disabled="isExportingPdf"
                >
                  <i class="fa fa-file-pdf me-1"></i> Generar PDF
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  @click="exportCsv"
                  :disabled="isExporting"
                >
                  <i class="fa fa-download me-1"></i> Exportar Excel
                </button>
              </div>
            </div>
          </div>

          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">

              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th style="width:60px"></th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Producto</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Ref</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Stock
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      P. Compra
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      P. Venta
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Semáforo
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Estado
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Última modificación
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Opciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="value in data" :key="value.id">
                    <td class="align-middle text-center" style="width:60px">
                      <div
                        class="inventory-img-wrapper"
                        @click="triggerImageUpload(value)"
                        :title="value.image_url ? 'Cambiar imagen' : 'Subir imagen'"
                      >
                        <img
                          v-if="value.image_url"
                          :src="value.image_url"
                          class="inventory-thumb"
                          alt="imagen"
                        />
                        <div v-else class="inventory-thumb-placeholder">
                          <i class="fa fa-image text-secondary"></i>
                        </div>
                        <div class="inventory-img-overlay">
                          <i class="fa fa-camera"></i>
                        </div>
                      </div>
                      <input
                        type="file"
                        accept="image/jpg,image/jpeg,image/png,image/webp"
                        class="d-none"
                        :ref="'imgInput_' + value.id"
                        @change="onImageSelected($event, value)"
                      />
                    </td>
                    <td>
                      <div class="d-flex align-items-center px-2 py-1">
                        <i
                          v-if="value.has_pending_purchase"
                          class="fa fa-clock text-warning me-2"
                          title="Compra pendiente"
                          aria-hidden="true"
                        />
                        <div class="d-flex flex-column justify-content-center">
                          <router-link
                            :to="{ name: 'Inventory Edit', params: { id: value.id }, query: suppliesListQuery }"
                            class="text-decoration-none"
                          >
                            <h6 class="mb-0 text-sm text-secondary">{{ value.name }}</h6>
                          </router-link>
                        </div>
                      </div>
                    </td>
                    <td style="max-width:150px">
                      <div class="px-2 py-1" style="max-width:150px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap" :title="value.ref">
                        <h6 class="mb-0 text-sm" style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap">{{ value.ref }}</h6>
                        <span class="badge badge-sm mt-1" :class="value.shopify_id ? 'bg-gradient-success' : 'bg-gradient-secondary'">
                          {{ value.shopify_id ? 'Shopify' : 'Local' }}
                        </span>
                      </div>
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ value.quantity }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ formatPrice(value.price) }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ formatPrice(value.sale_price) }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="badge badge-sm" :class="{
                        'bg-gradient-danger': value.quantity <= value.low,
                        'bg-gradient-warning': value.quantity <= value.medium,
                        'bg-gradient-success': value.quantity >= value.medium,
                      }">
                        {{
                          value.quantity >= value.high
                            ? 'Alto'
                            : value.quantity > value.low
                              ? 'Medio'
                              : 'Bajo'
                        }}
                      </span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="badge badge-sm"
                        :class="value.status == 1 ? 'bg-gradient-success' : 'bg-gradient-warning'">
                        {{ value.status == 1 ? 'Activo' : 'Inactivo' }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ new Date(value.updated_at).toLocaleDateString('es-ES') }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <router-link
                        :to="{ name: 'Inventory Edit', params: { id: value.id }, query: suppliesListQuery }"
                        class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                        data-original-title="Editar Registro">
                        <i class="fa fa-pencil-alt"></i>
                      </router-link>

                      <a @click="deleteUser(value.id)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                        style="margin-left: 15px;" data-toggle="tooltip" data-original-title="Eliminar registro">
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>
                  </tr>

                  <tr v-if="data.length === 0">
                    <td colspan="8" class="text-center text-xxs">No hay registros disponibles</td>
                  </tr>
                </tbody>
              </table>

              <!-- Paginación -->
              <div class="pagination p-3">
                <a v-for="link in links" :key="link.label" class="page-item cursor-pointer" @click="fetchData(link.url)"
                  :disabled="!link.url || link.active" :class="{ 'active': link.label === currentPage.toString() }">
                  {{ link.label }}
                </a>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- Modal Egresos de Inventario -->
    <div v-if="showEgresoModal" class="modal-backdrop-custom" @click.self="closeEgresoModal">
      <div class="modal-dialog-custom" role="dialog" aria-modal="true" aria-labelledby="egresoModalTitle">
        <div class="modal-content-custom">
          <div class="modal-header-custom">
            <h5 class="modal-title-custom" id="egresoModalTitle">
              <i class="fa fa-minus-circle me-1"></i> Egresos de inventario
            </h5>
            <button type="button" class="btn-close-custom" @click="closeEgresoModal" aria-label="Cerrar">&times;</button>
          </div>
          <div class="modal-body-custom">
            <p class="text-muted small mb-3">
              Escanee o digite el codigo de barras de la variante. Se restara 1 unidad al stock de esa variante.
            </p>
            <form @submit.prevent="handleEgresoBarcode">
              <div class="mb-3">
                <label for="egresoBarcode" class="form-control-label">Codigo de barras</label>
                <input
                  id="egresoBarcode"
                  ref="egresoBarcodeInput"
                  type="text"
                  class="form-control"
                  v-model="egresoBarcode"
                  placeholder="Escanee o digite el codigo..."
                  autocomplete="off"
                  :disabled="isProcessingEgreso"
                />
              </div>
              <div v-if="egresoLog.length" class="egreso-log mb-3">
                <div
                  v-for="(entry, idx) in egresoLog"
                  :key="idx"
                  class="egreso-log-entry"
                  :class="entry.type"
                >
                  <i :class="entry.type === 'success' ? 'fa fa-check-circle' : 'fa fa-exclamation-circle'"></i>
                  {{ entry.message }}
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer-custom">
            <button type="button" class="btn btn-sm btn-secondary" @click="closeEgresoModal">Cerrar</button>
            <button
              type="button"
              class="btn btn-sm btn-warning"
              @click="handleEgresoBarcode"
              :disabled="isProcessingEgreso || !egresoBarcode.trim()"
            >
              <i class="fa fa-minus-circle me-1"></i> Registrar egreso
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
import inventoryService from '../../../services/inventory.service';

export default {
  name: 'ProjectsList',
  data() {
    return {
      searchQuery: '',
      isExporting: false,
      isExportingPdf: false,
      isImporting: false,
      isSyncing: false,
      uploadingImageId: null,
      shopifyActive: false,
      showEgresoModal: false,
      egresoBarcode: '',
      isProcessingEgreso: false,
      egresoLog: [],
    };
  },
  computed: {
    ...mapGetters('inventory', ['allData', 'currentPage', 'lastPage', 'pagination', 'links']),
    currentPage() {
      return this.$store.state.inventory.currentPage;
    },
    lastPage() {
      return this.$store.state.inventory.lastPage;
    },
    data() {
      return this.allData;
    },
    links() {
      return this.$store.getters['inventory/links'];
    },
    suppliesListQuery() {
      const s = (this.searchQuery || '').trim();
      return s ? { search: s } : {};
    },
  },
  created() {
    const raw = this.$route.query.search;
    if (raw !== undefined && raw !== null && raw !== '') {
      this.searchQuery = Array.isArray(raw) ? String(raw[0]) : String(raw);
    }
  },
  methods: {
    formatPrice(value) {
      const numericValue = Number(value ?? 0);
      if (!Number.isFinite(numericValue)) return '0';
      return Math.floor(numericValue).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    syncSearchQueryToUrl() {
      const next = { ...this.$route.query };
      const trimmed = (this.searchQuery || '').trim();
      if (trimmed) {
        next.search = trimmed;
      } else {
        delete next.search;
      }
      if (JSON.stringify(next) === JSON.stringify(this.$route.query)) {
        return;
      }
      this.$router.replace({ query: next }).catch(() => {});
    },
    onSearchInput() {
      this.syncSearchQueryToUrl();
      this.fetchData(null);
    },
    async fetchData(pageUrl = null) {
      const params = {
        search: this.searchQuery,
        page: pageUrl ? new window.URL(pageUrl).searchParams.get("page") || 1 : 1
      };
      await this.$store.dispatch('inventory/fetchData', params);
    },
    async exportCsv() {
      if (this.isExporting) return;
      this.isExporting = true;
      try {
        const response = await this.$store.dispatch('inventory/exportCsv', this.searchQuery || null);
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', 'insumos.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
        await Swal.fire('Listo', 'Archivo Excel descargado correctamente.', 'success');
      } catch (error) {
        console.error('Error al exportar:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.data?.message || 'Error al exportar el Excel',
        });
      } finally {
        this.isExporting = false;
      }
    },
    async exportPdf() {
      if (this.isExportingPdf) return;
      this.isExportingPdf = true;
      try {
        const response = await inventoryService.exportPdf(this.searchQuery || null);
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
      } catch (error) {
        console.error('Error al generar PDF:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.data?.message || 'Error al generar el PDF',
        });
      } finally {
        this.isExportingPdf = false;
      }
    },
    async handleFileImport(event) {
      const file = event.target.files?.[0];
      const fileInput = event.target;
      if (!file) return;
      if (this.isImporting) return;
      this.isImporting = true;
      try {
        await this.$store.dispatch('inventory/importCsv', file);
        await Swal.fire('Listo', 'Insumos importados correctamente.', 'success');
        this.fetchData();
      } catch (error) {
        const msg = error?.data?.message || 'Error al importar el CSV';
        const errors = error?.data?.errors;
        const detail = errors?.length
          ? `Errores en filas: ${errors.map((e) => e.fila).join(', ')}`
          : '';
        await Swal.fire({
          icon: 'error',
          title: 'Error al importar',
          text: detail ? `${msg} ${detail}` : msg,
        });
      } finally {
        this.isImporting = false;
        if (fileInput) fileInput.value = '';
      }
    },
    triggerImageUpload(item) {
      const input = this.$refs['imgInput_' + item.id];
      if (input) {
        if (Array.isArray(input)) input[0].click();
        else input.click();
      }
    },
    async onImageSelected(event, item) {
      const file = event.target.files?.[0];
      const inputEl = event.target;
      const itemId = item.id;
      if (!file) return;
      if (this.uploadingImageId === itemId) return;
      this.uploadingImageId = itemId;
      try {
        const response = await this.$store.dispatch('inventory/uploadImage', { id: itemId, file });
        const newUrl = response?.data?.image_url;
        if (newUrl) {
          const storeItem = this.data.find((i) => i.id === itemId);
          if (storeItem) storeItem.image_url = newUrl;
        }
      } catch (error) {
        console.error('Error subiendo imagen:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.data?.message || 'No se pudo subir la imagen',
        });
      } finally {
        this.uploadingImageId = null;
        inputEl.value = '';
      }
    },
    async syncShopify() {
      if (this.isSyncing) return;
      this.isSyncing = true;
      try {
        const response = await this.$store.dispatch('shopify/syncInventory');
        const data = response?.data;
        await Swal.fire(
          'Sincronización completada',
          data?.message || `${data?.created ?? 0} creados, ${data?.updated ?? 0} actualizados.`,
          'success'
        );
        this.fetchData();
      } catch (error) {
        console.error('Error al sincronizar con Shopify:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.data?.message || 'Error al sincronizar con Shopify',
        });
      } finally {
        this.isSyncing = false;
      }
    },
    async deleteUser(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar',
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch('inventory/delete', userId);
          if (response && response.status >= 200 && response.status < 300) {
            this.fetchData();
            await Swal.fire(
              'Eliminado!',
              'El registro se ha eliminado correctamente.',
              'success'
            );
          } else {
            throw new Error(response.data.message || 'Error al eliminar el usuario');
          }
        }
      } catch (error) {
        console.error('Error al eliminar el registro:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    openEgresoModal() {
      this.showEgresoModal = true;
      this.egresoBarcode = '';
      this.egresoLog = [];
      this.$nextTick(() => {
        if (this.$refs.egresoBarcodeInput) {
          this.$refs.egresoBarcodeInput.focus();
        }
      });
    },
    closeEgresoModal() {
      this.showEgresoModal = false;
      this.egresoBarcode = '';
      this.egresoLog = [];
    },
    async handleEgresoBarcode() {
      const barcode = (this.egresoBarcode || '').trim();
      if (!barcode || this.isProcessingEgreso) return;
      this.isProcessingEgreso = true;
      try {
        const response = await inventoryService.subtractByBarcode(barcode);
        const msg = response?.data?.message || 'Egreso registrado correctamente.';
        this.egresoLog.unshift({ type: 'success', message: msg });
        if (this.egresoLog.length > 8) this.egresoLog.pop();
        this.fetchData();
      } catch (error) {
        const msg = error?.response?.data?.message || error?.data?.message || 'Error al procesar el egreso.';
        this.egresoLog.unshift({ type: 'error', message: msg });
        if (this.egresoLog.length > 8) this.egresoLog.pop();
      } finally {
        this.egresoBarcode = '';
        this.isProcessingEgreso = false;
        this.$nextTick(() => {
          if (this.$refs.egresoBarcodeInput) {
            this.$refs.egresoBarcodeInput.focus();
          }
        });
      }
    },
  },
  async mounted() {
    this.fetchData();
    try {
      const res = await this.$store.dispatch('settings/get');
      this.shopifyActive = !!res.data.shopify_active;
    } catch (e) {
      console.error('Error loading settings:', e);
    }
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.page-item {
  margin: 0 5px;
}

.active {
  font-weight: bold;
}

.inventory-img-wrapper {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 44px;
  cursor: pointer;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #e0e0e0;
}

.inventory-thumb {
  width: 44px;
  height: 44px;
  object-fit: cover;
  display: block;
}

.inventory-thumb-placeholder {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  font-size: 18px;
}

.inventory-img-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 16px;
  opacity: 0;
  transition: opacity 0.18s;
}

.inventory-img-wrapper:hover .inventory-img-overlay {
  opacity: 1;
}

/* Modal egresos de inventario */
.modal-backdrop-custom {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.modal-dialog-custom {
  width: 100%;
  max-width: 500px;
  margin: 1rem;
}

.modal-content-custom {
  background: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  overflow: hidden;
}

.modal-header-custom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #dee2e6;
}

.modal-title-custom {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
}

.btn-close-custom {
  background: none;
  border: none;
  font-size: 1.8rem;
  line-height: 1;
  color: #6c757d;
  cursor: pointer;
  padding: 0;
}

.btn-close-custom:hover {
  color: #000;
}

.modal-body-custom {
  padding: 1.25rem;
}

.modal-footer-custom {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 1rem 1.25rem;
  border-top: 1px solid #dee2e6;
}

.egreso-log {
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #e9ecef;
  border-radius: 0.375rem;
  padding: 0.5rem;
  background: #f8f9fa;
}

.egreso-log-entry {
  font-size: 0.85rem;
  padding: 0.35rem 0.5rem;
  margin-bottom: 0.25rem;
  border-radius: 0.25rem;
}

.egreso-log-entry.success {
  color: #0f5132;
  background: #d1e7dd;
}

.egreso-log-entry.error {
  color: #842029;
  background: #f8d7da;
}
</style>
